import { CampaignType } from "@vviinn/user-managment-client-ts";
import { ReactElement } from "react";
import {
  TextSearchIcon,
  VPCIcon,
  VPDIcon,
  VPRIcon,
  VPSIcon,
} from "../../icons";

export const styledIcon = (iconType: CampaignType, classNames = "") => {
  const CampaignTileIcons: Record<CampaignType, ReactElement> = {
    VPR: <VPRIcon className={classNames} />,
    VPS: <VPSIcon className={classNames} />,
    VPC: <VPCIcon className={classNames} />,
    VPD: <VPDIcon className={classNames} />,
    TEXT_SEARCH: <TextSearchIcon className={classNames} />,
  };
  return CampaignTileIcons[iconType];
};
